import { Button, styled } from '@mui/material';
import { CSSProperties, PropsWithChildren } from 'react';
import { ButtonProps } from './button-props';
import { LoadingIndicator } from '@components/loading-indicator';

const StyledButton = styled(Button, { target: 'wct-primary-button' })<{
  buttonVariant?: Props['buttonVariant'];
  styleOptions?: CSSProperties;
}>(({ theme: { palette }, buttonVariant, styleOptions }) => ({
  '&.Mui-disabled': {
    color: palette.primary.contrastText,
    opacity: 0.5,
  },
  '&.MuiButton-sizeLarge': {
    height: 56,
    borderRadius: 28,
  },
  backgroundImage: `linear-gradient(90deg, ${palette.primary.main} 0%, ${palette.primary.dark} 100%)`,
  ...((!buttonVariant || buttonVariant === 'one') && {
    minHeight: 42,
    textTransform: 'none',
    flexShrink: 0,
    borderRadius: 21,
    boxShadow: 'none',
    color: palette.primary.contrastText,
  }),
  ...(buttonVariant === 'two' && {
    display: 'flex',
    padding: '8px 22px',
    justifyContent: 'center',
    lineHeight: '26px',
    alignItems: 'center',
    gap: '8px',
    color: palette.common.white,
    fontWeight: 600,
    ...styleOptions,
  }),
}));

type Props = ButtonProps & {
  isBusy?: boolean;
  color?: 'primary' | 'info';
  size?: 'large' | 'medium' | 'small';
  buttonVariant?: 'one' | 'two';
  styleOptions?: CSSProperties;
};

const PrimaryButton = ({
  id,
  children,
  onClick,
  disabled,
  color = 'primary',
  isBusy,
  type,
  buttonVariant,
  size,
}: PropsWithChildren<Props>) => {
  return (
    <StyledButton
      id={id}
      variant="contained"
      buttonVariant={buttonVariant}
      type={type ?? 'button'}
      color={color}
      onClick={onClick}
      disabled={disabled || isBusy}
      size={size}
    >
      <span
        className="button-content"
        style={{ visibility: isBusy ? 'hidden' : 'visible' }}
      >
        {children}
      </span>
      <LoadingIndicator show={isBusy ?? false} isWhite />
    </StyledButton>
  );
};

export default PrimaryButton;
